module.exports = __webpack_public_path__ + "static/media/ico-domActive.15ef6186.svg";